
import React, { FC } from 'react';
import s from './ContentDisplay.module.css';
import {StepData} from "../../OnboardingPage";
import linkedin_post from "../../../../assets/img/linkedin_post.svg";
import insta_post from "../../../../assets/img/insta_post.svg";
import twitter_post from "../../../../assets/img/twitter_post.svg";
import facebook_post from "../../../../assets/img/facebook_post.svg";

interface ContentDisplayProps {
    step: number;
    linkedinToneList: StepData[];
    currentTemplate: any;
}

const ContentDisplay: FC<ContentDisplayProps> = ({ step, linkedinToneList, currentTemplate }) => {
    const activeTone = linkedinToneList.find((tone) => tone.isActive);
    const postImages: Record<string, string> = {
        linkedin: linkedin_post,
        instagram: insta_post,
        twitter: twitter_post,
        facebook: facebook_post,
    };
    return (
        <div
            className={s.content}
        >
            {step >= 2 && activeTone?.icon && (
                <img
                    key={activeTone?.text}
                    src={activeTone?.icon}
                    className={s.shape}
                />
            )}
            {step >= 2 && currentTemplate?.tag && (
                <img src={postImages[currentTemplate.tag]} className={s.image}/>
            )}


        </div>
    );
};

export default ContentDisplay;
